/** Service Desk console: Settings -> Connectors (SD-SC-17), part C: secrets, authentication and OAuth connection. */
export const serviceConnectorsC = {
  secrets: {
    title: "Mga secret",
    intro: "Naka-seal sa vault ng workspace at write-only: pagkatapos i-save, ang huling apat na karakter lang ang ipinapakita. Kapag nag-rotate, gumagana pa rin ang lumang halaga sa loob ng ilang oras para hindi maputol ang mga tawag na tumatakbo.",
    empty: "Wala pang secret. Hihingin dito ng authentication na nangangailangan ng key, token o password.",
    add: "Magdagdag ng secret",
    set: "Itakda ang halaga",
    setAria: "Itakda ang halaga ng {{name}}",
    setTitle: "Magdagdag ng secret",
    rotate: "I-rotate",
    rotateAria: "I-rotate ang {{name}}",
    rotateTitle: "I-rotate ang {{name}}",
    revoke: "Tapusin na ang overlap",
    revokeAria: "Tapusin na ang overlap ng {{name}}",
    revoked: "Hindi na gumagana ang dating halaga ng {{name}}",
    writeOnly: "Write-only: sine-seal ang halaga kapag nag-save ka at hindi na muling ipinapakita.",
    slot: "Pangalan ng slot",
    slotHint: "Ang pangalang binabasa ng authentication o ng isang template, tulad ng api_key.",
    nameInvalid: "Gumamit ng maliliit na titik, numero at underscore, magsimula sa titik.",
    value: "Halaga ng secret",
    valueRequired: "Ilagay ang halaga ng secret.",
    expires: "Mag-e-expire sa (opsyonal)",
    expiresHint: "Ipapaalala sa iyo bago huminto sa paggana ang credential.",
    expiresOn: "mag-e-expire sa {{date}}",
    overlap: "Panatilihing gumagana ang lumang halaga sa loob ng (oras)",
    overlapHint: "Tinatapos agad ng 0. Hanggang 168 oras.",
    overlapInvalid: "Gumamit ng buong numero mula 0 hanggang 168.",
    saved: "Na-save ang {{name}}",
    rotated: "Na-rotate ang {{name}}",
    setAt: "Itinakda noong {{date}}",
    rotatedAt: "Na-rotate noong {{date}}",
    lastFour: "Huling apat na karakter",
    previousActive: "Valid pa ang lumang halaga",
    neededNotSet: "Kailangan ng authentication, wala pang halaga",
    notSet: "Wala pang halaga",
    missingCount_one: "{{count}} secret ang kulang",
    missingCount_other: "{{count}} secret ang kulang",
    deleteAria: "Burahin ang {{name}}",
    deleteTitle: "Burahin ang secret na {{name}}?",
    deleteBody: "Papalya ang mga tawag na bumabasa sa slot na ito hanggang may itakdang bagong halaga.",
    deleteConfirm: "Burahin ang secret",
    deleted: "Nabura ang {{name}}",
  },
  oauth: {
    title: "OAuth na koneksyon ({{name}})",
    about: "Gumagamit ang environment na ito ng OAuth 2 authorization code. Naka-seal ang mga token at nire-refresh ng Sagot.",
    status: { connected: "Nakakonekta", not_connected: "Hindi nakakonekta", expired: "Nag-expire", revoked: "Binawi" },
    expires: "Mag-e-expire ang access sa {{date}}",
    unknown: "Hindi namin mabasa ang katayuan ng koneksyon.",
    connect: "Ikonekta",
    reconnect: "Ikonekta muli",
    disconnect: "Idiskonekta",
    disconnectTitle: "Idiskonekta ang environment na ito?",
    disconnectBody: "Binabawi ang mga token. Papalya ang mga tawag hanggang may muling kumonekta.",
    disconnected: "Naidiskonekta",
  },
  auth: {
    title: "Authentication",
    type: "Uri ng authentication",
    slotHint: "Ang PANGALAN ng secret slot na may hawak ng halaga.",
    listHint: "Paghiwalayin ng espasyo ang mga scope.",
    secretsNext: "Sa Secrets card itinatakda ang mga halaga ng secret (key, token, password) pagkatapos mong mag-save. Hindi kailanman bahagi ng configuration na ito ang mga ito.",
    rawLabel: "Configuration (JSON)",
    rawHint: "Mga pangalan, URL at placeholder ng secret slot lang. Huwag kailanman mag-paste ng halaga ng secret dito.",
    problems: { required: "Kailangan ang field na ito.", rawInvalid: "Hindi ito wastong JSON." },
    types: {
      none: "Wala",
      api_key_header: "Key na ipinapadala sa iyong system (header)",
      api_key_query: "Key na ipinapadala sa iyong system (query string)",
      bearer_token: "Bearer token",
      basic: "Basic (user name at password)",
      hmac_signing: "HMAC request signing",
      oauth2_client_credentials: "OAuth 2 client credentials",
      oauth2_authorization_code: "OAuth 2 authorization code (may refresh)",
      oauth2_custom_token: "Custom na token endpoint",
      integration: "Managed integration (Zoho, Google)",
      mtls: "Client certificate (mTLS)",
    },
    about: {
      none: "Hindi nangangailangan ng credential ang system.",
      api_key_header: "Ipinapadala ang key sa header na papangalanan mo, na may opsyonal na prefix tulad ng Token.",
      api_key_query: "Ipinapadala ang key bilang query parameter na papangalanan mo.",
      bearer_token: "Nagpapadala ng Authorization: Bearer <token>.",
      basic: "Ipinapadala ang user name at password bilang HTTP Basic.",
      hmac_signing: "Pinipirmahan ang bawat request gamit ang shared secret at ipinapadala ang pirma sa isang header.",
      oauth2_client_credentials: "Kumukuha ng access token mula sa token URL gamit ang client id at secret, at nire-refresh ito.",
      oauth2_authorization_code: "Minsang kumokonekta ang isang tao sa consent screen ng provider; nire-refresh ng Sagot ang mga token.",
      oauth2_custom_token: "Token endpoint na hindi karaniwang OAuth 2: ilarawan ang request at kung saan babasahin ang token.",
      integration: "Ginagamit muli ang mga token ng integration na nakakonekta na.",
    },
    fields: {
      header_name: "Pangalan ng header",
      param_name: "Pangalan ng query parameter",
      secret: "Secret slot",
      prefix: "Prefix ng halaga",
      scheme: "Scheme",
      username_secret: "Slot ng user name",
      password_secret: "Slot ng password",
      algorithm: "Algorithm",
      signature_header: "Header ng pirma",
      string_to_sign: "String na lalagdaan",
      signature_encoding: "Encoding ng pirma",
      timestamp_header: "Header ng timestamp",
      token_url: "Token URL",
      authorization_url: "Authorization URL",
      client_id_secret: "Slot ng client id",
      client_secret_secret: "Slot ng client secret",
      client_auth: "Ipadala ang client credentials",
      scopes: "Mga scope",
      pkce: "Gumamit ng PKCE",
      integration: "Integration",
    },
    options: {
      client_auth: { basic: "Sa Basic header", body: "Sa body ng request" },
      algorithm: { sha256: "SHA-256", sha512: "SHA-512" },
      signature_encoding: { hex: "Hex", base64: "Base64", base64url: "Base64 (URL-safe)" },
      integration: { zoho: "Zoho", google: "Google" },
    },
  },
};
